import { createModuleApi } from '@wit-support/admin-client-core';
/**
 * Клиент экрана «Настройки».
 *
 * Три источника, один экран. Роутов три, потому что у них разные тиры права на
 * ЗАПИСЬ (`llm.manage` / `billing_settings.manage` / владелец-супервайзер на
 * системных флагах) — см. рассуждение в
 * `packages/admin-contracts/src/system-settings.ts`. Оператору эта граница не
 * видна и видна быть не должна: он открывает одну страницу.
 */
const api = createModuleApi({ errorFormat: 'raw' });
export function setSettingsApiBaseUrl(url) {
    api.setBaseUrl(url);
}
// ───────────────────────────── Тумблеры (llm-settings) ─────────────────────
//
// Имя роута историческое: под ним живут не только флаги языковой модели, но и
// порядок инбокса, перезапуск автоматики и второй поиск клиента. Ровно об этом
// предупреждает комментарий у `INBOX_SORT_BY_ACTIVITY_KEY` в контрактах.
/** Пять булевых флагов. Требует `llm.read` (supervisor+). */
export async function getLlmSettings() {
    return api.get('/api/llm-settings');
}
/** Частичный патч. Требует `llm.manage` (supervisor+). */
export async function updateLlmSettings(body) {
    return api.patch('/api/llm-settings', body);
}
// ─────────────────────── Порог кита (billing-settings) ──────────────────────
/** Действующий порог и признак того, задан ли он явно. Требует `billing_settings.read`. */
export async function getBillingSettings() {
    return api.get('/api/billing-settings');
}
/** Задать порог. Требует `billing_settings.manage` (supervisor+). */
export async function updateBillingSettings(body) {
    return api.patch('/api/billing-settings', body);
}
// ───────────────────── Системные флаги (system-settings) ────────────────────
/** Склейка алертов + напоминание в Telegram. Требует `settings.read` (member+). */
export async function getSystemSettings() {
    return api.get('/api/system-settings');
}
/**
 * Частичный патч. Право проверяется ПОФЛАЖНО на сервере: склейка алертов —
 * владелец, уведомления — супервайзер+.
 */
export async function updateSystemSettings(body) {
    return api.patch('/api/system-settings', body);
}
//# sourceMappingURL=api.js.map